import React from "react";
import type { DashboardIssueBreakdown } from "@models/dashboard";

interface IssuesTooltipProps {
    breakdown: DashboardIssueBreakdown;
    children: React.ReactNode;
}

// Hover/focus breakdown for the Issues Found tile. Built on daisyUI 5's
// tooltip-content variant (the shared @common Tooltip only takes a string
// `data-tip`, and this needs three label/count rows).
export const IssuesTooltip = ({ breakdown, children }: IssuesTooltipProps) => {
    // Label semantics are LOCKED (F2, Sklar 2026-07-23): pendingApplications
    // counts ORGANIZATIONS awaiting first approval; pendingCertReviews counts
    // LOCATIONS. Do not swap the units.
    // No "Charged but not saved" row: removed by ruling (AO-03, Sklar
    // 2026-10-13) — nothing countable feeds it.
    const rows: [string, number][] = [
        ["Failed payments", breakdown.failedPayments],
        ["Pending applications (orgs)", breakdown.pendingApplications],
        ["Pending cert reviews (locations)", breakdown.pendingCertReviews],
    ];

    return (
        <div className="tooltip tooltip-bottom w-full" tabIndex={0}>
            <div className="tooltip-content">
                <ul className="flex flex-col gap-1 p-2 text-left text-sm">
                    {rows.map(([label, count]) => (
                        <li
                            key={label}
                            className="flex justify-between gap-4"
                        >
                            <span>{label}</span>
                            <span className="font-bold">{count}</span>
                        </li>
                    ))}
                </ul>
            </div>
            {children}
        </div>
    );
};
